import React, { FC } from 'react'
import { getCostBreakdown } from 'redux/reducers/logicStore/logicStore.selectors'
import { useSelector } from 'react-redux'
import { BasketPriceContainerStyle } from './BasketPriceContainerStyle'

interface BasketPriceContainerProps {
  prePriceText?: string
  postPriceText?: string
}

const BasketPriceContainer: FC<BasketPriceContainerProps> = ({
  prePriceText,
  postPriceText,
}) => {
  // Based on the page route PCW or Behaviourlab, price should be taken from the relevant selector-- needs modification when PCW redux store is ready
  const price = useSelector(getCostBreakdown)

  return (
    <BasketPriceContainerStyle>
      {prePriceText && (
        <div dangerouslySetInnerHTML={{ __html: prePriceText }} />
      )}
      <h3>
        Total Price:
        <span>{price}</span>
      </h3>
      {postPriceText && (
        <div dangerouslySetInnerHTML={{ __html: postPriceText }} />
      )}
    </BasketPriceContainerStyle>
  )
}

export default BasketPriceContainer
